import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { User } from '../../models/login/login';
import {httpOptions} from '../../configurations/configuration';
import { environment } from '../../../environments/environment';
import {EmptyObservable} from "rxjs/observable/EmptyObservable";
import {  BehaviorSubject } from 'rxjs';
import {Menus} from '../../models/menus/menus';
import { ENETDOWN } from 'constants';

@Injectable({
  providedIn: 'root'
})
export class LoggedinService {

  public userType: string = 'SuperAdmin';
  public currentPageTitle: string = 'Dashboard';
  private loginURL: string;
  menu: Menus;
  private fpUrl: string;
  private isLogin = new BehaviorSubject<boolean>(false);
  currentStatus = this.isLogin.asObservable(); 
  private resetPasswordUrl: string;
  changeStatus(login: boolean) {
    this.isLogin.next(login)
  }
  constructor(private http: HttpClient) { 
    this.loginURL = environment.baseURI + environment.loginUrl;
    this.fpUrl = environment.baseURI + environment.forgotPasswordUrl;
    this.resetPasswordUrl = environment.baseURI + environment.resetPasswordUrl;
    this.menu = new Menus();
    console.log(this.menu)
  }

  public set setUserType(value: string) {
    this.userType = value;
  }

  public get getUserType(): string {
    return this.userType;
  }

  public setCurrentPageTitle(value: string) {
    this.currentPageTitle = value;
    console.log(this.currentPageTitle)
    localStorage.setItem('currentPage', this.currentPageTitle);
  }

  public getCurrentPageTitle(): string {
    console.log(localStorage.getItem('currentPage'))
    return localStorage.getItem('currentPage');
  }

  setMenuList(menu) {
    console.log(menu)
    localStorage.setItem("menuList", JSON.stringify(menu));
  }

  static getMenuList() {
    console.log(localStorage.getItem("menuList"));
      return localStorage.getItem("menuList");
  }

  setMenu() {
    this.menu.dashboard=false;
    this.menu.createEvent = false;
    this.menu.myEvents = false;
    this.menu.Speaker = false;
    this.menu.Training = false;
    this.menu.uploadReferenceMaterial = false;
    this.menu.manageSpeakerContent = false;
    this.menu.myStory = false;
    this.menu.venue = false;
    this.menu.attendeeListing = false;
    this.menu.myProfile = false;
    this.menu.addExpense = false;
    this.menu.reconcileExpense = false;
    this.menu.reports = false;
    this.menu.searchSpeaker = false;
    this.menu.addSpeaker = false;
    this.menu.searchVenue = false;
    this.menu.addVenue = false;
    this.menu.upcomingEventFilter = true;
    this.menu.notificationsFilter = false;
    this.menu.taskFilter = true;
    this.menu.editVenue = false;
  }

  login (postBody: any): Observable<User> {
    
    return this.http.post<User>(this.loginURL, postBody, httpOptions);
    // .catch((err: HttpErrorResponse) => {
    //   if (err.error instanceof Error) {
    //     console.error('An error occurred:', err.error.message);
    //   } else {
    //     // The backend returned an unsuccessful response code.
    //     // The response body may contain clues as to what went wrong,
    //     console.error(`Backend returned code ${err.status}`);
    //   }
    //   return new EmptyObservable<Response>();

    // });
  }

  forgotPassword(postBody) {
    return this.http.post(this.fpUrl, postBody, httpOptions);
  }
  
  resetPassword(postBody) {
    return this.http.post(this.resetPasswordUrl, postBody, httpOptions);
  }

}
